export default {
    name: 'products',
    component: () => import(/* webpackChunkName: "products-layout" */ '@/modules/products/layouts/Layout'),
    children: [
        {
            path: '',
            name: 'dashboard.products.index',
            component: () => import(/* webpackChunkName: "products-index" */ '@/modules/products/views/Index'),
        },
        {
            path: 'create',
            name: 'dashboard.products.create',
            component: () => import(/* webpackChunkName: "products-create" */ '@/modules/products/views/Create'),
        },
        {
            path: ':id/edit',
            name: 'dashboard.products.edit',
            component: () => import(/* webpackChunkName: "products-edit" */ '@/modules/products/views/Edit'),
        },
    ]
}